import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block w-full h-full p-0 border-2 border-transparent bg-transparent cursor-pointer hover:opacity-80 focus:outline-none overflow-hidden rounded-lg gallery-button" }

interface Props {
    accentColor: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GalleryButton',
  props: {
    accentColor: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "38d6cf45": (_ctx.accentColor)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})